import { observer } from 'mobx-react';
import React from 'react';
import logo from '../../assets/images/logo.png';
import AuthStore from '../../store/auth/AuthStore';
import { Icon24ArrowLeftOutline } from '@vkontakte/icons';
import { useNavigate } from 'react-router-dom';

function nilFirst(t: number) {
  if (t.toString().length === 1) return '0' + t;
  return t.toString();
}

function toTime(sec = 0) {
  return nilFirst(Math.trunc(sec / 60)) + ':' + nilFirst(sec % 60)

}

const OTPForm: React.FC = observer(() => {
  const navigate = useNavigate();

  return (
    <div
      className='sr__authForm'
    >
      <Icon24ArrowLeftOutline
        width={20}
        height={20}
        color='var(--sr--color_text_secondary)'
        className='sr__authForm__goBack'
        onClick={AuthStore.onClickGoBack}
      />
      <img
        className='sr__authForm__logo'
        src={logo}
        alt='ScoReflect logotype'
      />
      <h1 className='sr__authForm__title'>Введите код из Telegram</h1>
      {/*<h4 className='sr__authForm__description'>SMS-сообщение отправлено на номер <b style={{ color: 'var(--sr--color_text_accent)', textWrap: 'nowrap' }}>{AuthStore.phoneNumber}</b></h4>*/}
      <div className='sr__authForm__input'>
        <input
          className='sr__authForm__textField'
          inputMode='numeric'
          name='otp'
          autoComplete='phoneNumber'
          placeholder='Проверочный код'
          type='text'
          maxLength={7}
          onChange={AuthStore.onChangeOTP}
        />
        <div className='sr__authForm__input--error' id='otp_error'>Неверный одноразовый код</div>
      </div>
      <button
        className='sr__authForm__button'
        style={{
          marginBottom: '0'
        }}
        onClick={() => AuthStore.onClickLogin(navigate)}
      >Продолжить</button>
      <button
          className='sr__authForm__button--plain'
          style={{
            marginBottom: '0'
          }}
          onClick={() => window.open('https://t.me/scoreflect_bot')}
        >Перейти в Telegram</button> 
      {/*
        AuthStore.ttl === 0 ?
        <button
          className='sr__authForm__button--plain'
          style={{
            marginBottom: '0'
          }}
          onClick={AuthStore.onClickContinue}
        >Отправить ещё раз</button> :
        <p className='sr__authForm__resend'>SMS придет в течение {toTime(AuthStore.ttl)}</p>
      */}
    </div>
  );
});

export default OTPForm;